import { Checkbox, DataSource, Label, Layout, Panel, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRecurringMiscInvoiceList extends Layout {
    checkboxActive: Checkbox;
    checkboxInactive: Checkbox;
    labelDisplayCaption: Label;
    panelCheckboxes: Panel;
    searchpanelRecurringMiscInvoices: SearchPanel;
    sourceMiscBill: DataSource;
    tableRecurringMiscInvoices: Table;
    textboxAllocationCode: Textbox;
    textboxArCycleCodeIdSearch: Textbox;
    textboxBillType: Textbox;
    textboxCurrencyType: Textbox;
    textboxCustomerIdSearch: Textbox;
    textboxEndDate: Textbox;
    textboxInvoiceNoString: Textbox;
    textboxLastBillDate: Textbox;
    textboxNextInvoiceDate: Textbox;
    textboxOrderId: Textbox;
    textboxReferenceNumber: Textbox;
    textboxStartDate: Textbox;
    textboxTotal: Textbox;
}
